












































import { Vue, Component, Prop } from 'vue-property-decorator';
import { dom } from '@fortawesome/fontawesome-svg-core';
import { mapState } from 'vuex';
import moment from 'moment';
import comment from '@/components/CommentComponent.vue';
import postCom from '@/components/CreatePostComponent.vue';
import * as firebase from 'firebase/app';
import User from '@/model/User';
import RoleType from '@/userManagement/RoleType';
import { COLLECTION_ORGANIZATIONS, COLLECTION_POSTS, COLLECTION_USERS } from '@/model/AppConstants';
import FirebaseUtil from '@/model/FirebaseUtil';
import PermUtil from '@/model/PermUtil';
import HomePostView from '@/components/HomePostView.vue';
import CreatePostComponent from '@/components/CreatePostComponent.vue';

@Component({
  components: {
    postCom,
    CreatePostComponent,
    HomePostView,
  },
})
export default class Home extends Vue {
  show= false;

  loading = false;

  showIcon = true;

  icon = false;

  async mounted() {
    await this.$store.dispatch('bindCurrentUser', this.currentUser.uid);
    dom.watch();
    this.loadPosts();
  }

  async loadPosts() {
    await this.$store.dispatch('bindFriends');
    await this.$store.dispatch('bindPeople');
    await this.$store.dispatch('bindcompaignPosts');
    const orgIds = this.currentUser.organizations;
    const userIds = this.$store.state.friends.map((f: any) => f.uid);
    userIds.push(this.currentUser.uid);
    if (userIds.length) {
      this.$store.dispatch('bindHomePagePosts', this.refMap(userIds));
    }
    if (orgIds.length) {
      this.$store.dispatch('bindHomePageOrgPosts', this.orgRefMap(orgIds));
    }
    await this.$store.dispatch('bindFollowingOrgs', this.currentUser.uid);
    if (this.followingOrgs.length) {
      this.$store.dispatch('bindHomePageFollowerPosts', this
        .orgRefMap(this.followingOrgs.concat(orgIds)));
    }
  }
  // eslint-disable-next-line
  orgRefMap(orgs: any[]) {
    return orgs.map((f: any) => FirebaseUtil.ObjectToRef(COLLECTION_ORGANIZATIONS, f));
  }
  // eslint-disable-next-line
  refMap(frnds: any[]) {
    return frnds.map((f: any) => FirebaseUtil.ObjectToRef(COLLECTION_USERS, f));
  }

  get followingOrgs() {
    return this.$store.state.followingOrgs.map((Org: any) => Org.id);
  }

  get syntheticPosts() {
    const posts = this.$store.state.homePagePosts;
    // if (this.campaignAdds) {
    //   posts.splice(2, 1, this.campaignAdds);
    // }
    const re = posts.concat(this.homePageFollowerPosts);
    const e = re.splice(0, re.length, ...(new Set(re)));
    const d = re.filter((elem: any, index: any, self: any) => index === self
      .indexOf((p: any) => (p.id === elem.id && p.content === elem.content)));
    return e;
  }

  get homePageFollowerPosts() {
    return this.$store.state.homePageFollowerPosts;
  }

  get homeOrgPosts() {
    return this.$store.state.homePageOrgPosts;
  }

  get campaignAdds() {
    const adds = this.$store.state.compaignPosts;
    return adds[0];
  }

  get currentUser() {
    return this.$store.state.currentUser;
  }

  get freshCurrentUser() {
    return this.$store.state.freshCurrentUser;
  }
}
